// extracted by mini-css-extract-plugin
export default {"site-footer-link":"j9zseiRRJr42IWmIVFG2"};